import { addEvent, extend, $, $$ } from './helper-functions'

export class VideoBoxVariant3 {
  constructor (settings, selectors, classes) {
    this.settings = extend({
      defaultVideoRatio: 16 / 9,
      saveSettingWithCookie: true
    }, settings)

    this.selectors = extend({
      videoBox: '.video-box--variant-3',
      playButton: '.video-box__play',
      stopButton: '.video-box__stop',
      preview: '.video-box__preview-picture',
      vimeoIframe: '.video-box__vimeo-iframe',
      consent: '.video-box__consent',
      consentButton: '.video-box__consent-button'
    }, selectors)

    this.classes = extend({
      setPreview: 'video-box--preview',
      setConsent: 'video-box--consent',
      setPlay: 'video-box--play',
      playerReady: 'video-box__player--ready'
    }, classes)

    this.$Cookies = require('js-cookie')
    this.videoBoxes = $$(this.selectors.videoBox)
  }

  init () {
    this.videoBoxes.forEach(videoBox => {
      const consentButton = $(this.selectors.consentButton, videoBox)
      const preview = $(this.selectors.preview, videoBox)

      if (consentButton && this.settings.saveSettingWithCookie === true && this.getCookie('ShowVimeo') === '1') {
        consentButton.checked = true
      }

      if (preview) {
        videoBox.classList.add(this.classes.setPreview)
      } else {
        this.goToVideo(videoBox, false)
      }
    })

    this.addEvents()
  }

  addEvents () {
    this.videoBoxes.forEach(videoBox => {
      const playButtons = $$(this.selectors.playButton, videoBox)
      const stopButtons = $$(this.selectors.stopButton, videoBox)
      const consentButtons = $$(this.selectors.consentButton, videoBox)

      playButtons.forEach(playButton => {
        addEvent(playButton, 'click', () => {
          const videoBox = playButton.closest(this.selectors.videoBox)

          this.goToVideo(videoBox)
        })
      })

      stopButtons.forEach(stopButton => {
        addEvent(stopButton, 'click', () => {
          const videoBox = stopButton.closest(this.selectors.videoBox)

          this.stopVideo(videoBox)
        })
      })

      consentButtons.forEach(consentButton => {
        addEvent(consentButton, 'click', () => {
          if (videoBox.classList.contains(this.classes.setConsent)) {
            videoBox.classList.remove(this.classes.setConsent)
            videoBox.classList.add(this.classes.setPlay)

            if (this.settings.saveSettingWithCookie === true) {
              consentButtons.forEach(consentButton2 => {
                consentButton2.checked = true
              })

              this.videoBoxes.forEach(videoBox2 => {
                if (videoBox2.classList.contains(this.classes.setConsent) && videoBox2 !== videoBox) {
                  videoBox2.classList.remove(this.classes.setConsent)
                  videoBox2.classList.add(this.classes.setPreview)
                }
              })

              this.setCookie('ShowVimeo', '1')
            }

            this.showVideo(videoBox)
          } else {
            consentButtons.forEach(ConsentButton2 => {
              if (ConsentButton2 !== consentButton) {
                ConsentButton2.checked = false
              }
            })

            this.videoBoxes.forEach(videoBox2 => {
              videoBox2.classList.remove(this.classes.setPlay)
              videoBox2.classList.add(this.classes.setConsent)
            })

            if (this.settings.saveSettingWithCookie === true) {
              this.setCookie('ShowVimeo', '0')
            }

            this.hideAllVideos()
          }
        })
      })
    })
  }

  goToVideo (videoBox, autoplay = true) {
    if (this.settings.saveSettingWithCookie === false) {
      videoBox.classList.remove(this.classes.setPreview)
      videoBox.classList.add(this.classes.setConsent)
    } else {
      if (this.getCookie('ShowVimeo') === '1') {
        videoBox.classList.remove(this.classes.setPreview)
        videoBox.classList.add(this.classes.setPlay)

        this.showVideo(videoBox, autoplay)
      } else {
        videoBox.classList.remove(this.classes.setPreview)
        videoBox.classList.add(this.classes.setConsent)
      }
    }
  }

  showVideo (videoBox) {
    const vimeoIframe = $(this.selectors.vimeoIframe, videoBox)

    vimeoIframe.src = vimeoIframe.dataset.source
  }

  hideAllVideos () {
    this.videoBoxes.forEach(videoBox => {
      this.stopVideo(videoBox)
    })
  }

  stopVideo (videoBox) {
    const vimeoIframe = $(this.selectors.vimeoIframe, videoBox)

    vimeoIframe.src = ''
  }

  setCookie (name = '', value = '0') {
    this.$Cookies.set(name, value, {
      expires: 365,
      path: '/'
    })
  }

  getCookie (name) {
    return this.$Cookies.get(name)
  }
}

export default VideoBoxVariant3
